import * as React from 'react';

import i18n from 'helper/i18n';
import { memo } from 'react';

type FameLevelProps = {
	level: string | null;
	descriptions?: string[] | null;
	achieved?: boolean;
	modifier?: string;
	doubleDigit?: boolean;
};

type FameLevelState = {};

export const FameLevelLevels: { [levelId: string]: number } = {
	L01: 1,
	L02: 2,
	L03: 3,
	L04: 4,
	L05: 5,
	L06: 6,
	L07: 7,
	L08: 8,
	L09: 9,
	L10: 10,
};

class FameLevel extends React.Component<FameLevelProps, FameLevelState> {
	public static defaultProps = {
		achieved: false,
		doubleDigit: false,
	};

	public getClassNames() {
		const { level, modifier, doubleDigit } = this.props;
		const classNames = ['m-fame-level'];

		if (modifier) {
			classNames.push(`m-fame-level--${modifier}`);
		}

		if (doubleDigit && typeof level === 'string' && FameLevelLevels[level] >= 10) {
			classNames.push(`m-fame-level--double-digit`);
		}

		return classNames.join(' ');
	}

	public renderDescriptions() {
		const { descriptions } = this.props;

		if (!descriptions || !descriptions.length) {
			return null;
		}

		const levelDescriptions = descriptions.map((label: string, key: number | string) => {
			return (
				<span key={key} className="m-fame-level__description-text">
					{label}
				</span>
			);
		});

		return <div className="m-fame-level__description">{levelDescriptions}</div>;
	}

	public renderLevel() {
		const { level, achieved } = this.props;
		const classNames = ['m-fame-level__number'];

		if (achieved) {
			classNames.push('state-m-fame-level__number--achieved');
		}

		return level && <div className={classNames.join(' ')}>{FameLevelLevels[level]}</div>;
	}

	public render() {
		const { level } = this.props;

		if (level === null) {
			return null;
		}

		return (
			<div className={this.getClassNames()}>
				<div className="m-fame-level__info">
					<span className="m-fame-level__info-title">
						{i18n(`react.impulsCoach.components.fameLevel.myLevel`)}
					</span>
					<span className="m-fame-level__info-text">
						{i18n(`react.impulsCoach.components.fameLevel.${level}.label`)}
					</span>
				</div>
				{this.renderLevel()}
				{this.renderDescriptions()}
			</div>
		);
	}
}

export { FameLevel };
export default memo(FameLevel, (prevProps, nextProps) => {
	return (
		prevProps.level === nextProps.level &&
		prevProps.achieved === nextProps.achieved &&
		prevProps.modifier === nextProps.modifier
	);
});
